import Header from "../components/landing/Header";
import Hero from "../components/landing/Hero";
import Problem from "../components/landing/Problem";
import HowItWorks from "../components/landing/HowItWorks";
import Features from "../components/landing/Features";
import Trust from "../components/landing/Trust";
import Pricing from "../components/landing/Pricing";
import FAQ from "../components/landing/FAQ";
import Footer from "../components/landing/Footer";

export default function Landing() {
  return (
    <div className="bg-[#FAFAFA] text-[#0F172A]" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Problem />
        <HowItWorks />
        <Features />
        <Trust />
        <Pricing />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
